const QUICK_SETUP_TYPE = Object.freeze({
  hair: 'hair',
  beauty: 'beauty',
});

// noinspection JSUnusedGlobalSymbols
export default QUICK_SETUP_TYPE;
